import { WorkspaceReference } from '../../../domain/platform';
import { OrganizationScope } from '../organization';

export interface WorkspaceContextV2 extends OrganizationScope {
    workspace: WorkspaceReference;
}

export function isWorkspaceContext(context: WorkspaceContextV2 | OrganizationScope): context is WorkspaceContextV2{
    return (context as WorkspaceContextV2).workspace !== undefined
}